import React from 'react';
import ToastBase from './ToastBase';

import TToast from './@types/TToast';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

const Error: React.FC<TToast> = ({ children, icon, ...rest }) => (
  <ToastBase signal={FeedbackSignals.Error} icon={icon} {...rest}>
    {children}
  </ToastBase>
);

Error.displayName = 'ErrorToast';

export default Error;
